import { DEFAULT_GROUPING } from '../../state';
export const onDisconnect = (group, updater) => ({
    type: 'DISCONNECT',
    payload: {
        groupId: group,
        updater,
    },
});
export const disconnectUpdaterFromGroup = ({ groupId, updater }, groups) => {
    var _a;
    const currentGrouping = (_a = groups[groupId]) !== null && _a !== void 0 ? _a : DEFAULT_GROUPING;
    return {
        ...groups,
        [groupId]: {
            ...currentGrouping,
            connectedCharts: currentGrouping.connectedCharts.filter((connectedUpdater) => connectedUpdater !== updater),
        },
    };
};
